import { WebserviceUrl } from "@tm/data/webserviceUrls"
import { ajaxAuth } from "@tm/utils"
import { ShowModelsByEngineCodeRequest, ShowModelsByEngineCodeResponse } from "./models"

export function showModelsByEngineCode(body: ShowModelsByEngineCodeRequest) {
    const url = `${WebserviceUrl.VehiclesTrucks}/ShowModelsByEngineCode`

    return ajaxAuth<ShowModelsByEngineCodeResponse>({ url, body, method: "GET" })
}
